import { render } from "./OAuthHandler.vue?vue&type=template&id=05cd0282&lang=pug"
import script from "./OAuthHandler.vue?vue&type=script&lang=js"
export * from "./OAuthHandler.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__